import React from 'react';
import './Recipes.css';

// Dummy image paths - replace with your actual images
const image1 = '/assets/1.png';
const image2 = '/assets/2.png';
const image3 = '/assets/3.png';
const image4 = '/assets/4.png';
const image5 = '/assets/5.png';

interface Recipe {
  id: number;
  title: string;
  description: string;
  image: string;
  difficulty: string;
  time: string;
  rating: number;
  category: string;
}

const Recipes: React.FC = () => {
  const recipes: Recipe[] = [
    {
      id: 1,
      title: 'Kremalı Tavuklu Makarna',
      description: 'Sadece 25 dakikada, restoran kalitesinde kremalı bir lezzet şöleni. AI, en iyi lezzet için oranları ayarladı.',
      image: image1,
      difficulty: 'Kolay',
      time: '25 dk',
      rating: 4.9,
      category: 'Ana Yemek'
    },
    {
      id: 2,
      title: 'Avokadolu Yaz Salatası',
      description: 'Sıcak günler için ferahlatıcı ve vitamin dolu bir başlangıç. Hem hafif hem de doyurucu.',
      image: image2,
      difficulty: 'Çok Kolay',
      time: '10 dk',
      rating: 4.8,
      category: 'Salata'
    },
    {
      id: 3,
      title: 'Belçika Çikolatalı Brownie',
      description: 'Yoğun çikolata krizleriniz için yapay zekanın mükemmelleştirdiği, içi ıslak, dışı çıtır brownie.',
      image: image3,
      difficulty: 'Orta',
      time: '45 dk',
      rating: 4.9,
      category: 'Tatlı'
    },
    {
      id: 4,
      title: 'Zencefilli Mercimek Çorbası',
      description: 'Soğuk algınlığına meydan okuyan, içinizi ısıtacak şifalı ve lezzetli bir başlangıç.',
      image: image4,
      difficulty: 'Kolay',
      time: '30 dk',
      rating: 4.7,
      category: 'Çorba'
    },
    {
      id: 5,
      title: 'Ballı Susamlı Tavuk',
      description: 'Asya mutfağından ilham alan, yapışkan sosuyla parmaklarınızı yiyeceğiniz bir tarif.',
      image: image5,
      difficulty: 'Orta',
      time: '35 dk',
      rating: 4.8,
      category: 'Ana Yemek'
    }
  ];

  return (
    <section id="recipes" className="recipes">
      <div className="container">
        <div className="recipes-header">
          <h2 className="section-title">Yapay Zekanın Mutfak Harikaları</h2>
          <p className="section-subtitle">
            FoodQuick'in yapay zekasının sizin için seçtiği, hem pratik hem de damak çatlatan tariflere göz atın.
          </p>
        </div>

        <div className="recipes-grid">
          {recipes.map((recipe) => (
            <div key={recipe.id} className="recipe-card">
              <div className="recipe-image-wrapper">
                <img src={recipe.image} alt={recipe.title} className="recipe-image" />
                <div className="recipe-category-badge">{recipe.category}</div>
                <div className="recipe-rating-badge">
                  <span className="rating-star">⭐</span>
                  <span>{recipe.rating}</span>
                </div>
              </div>
              
              <div className="recipe-content">
                <h3 className="recipe-title">{recipe.title}</h3>
                <p className="recipe-description">{recipe.description}</p>
                
                <div className="recipe-meta">
                  <div className="meta-item">
                    <span className="meta-icon">⏱️</span>
                    <span className="meta-text">{recipe.time}</span>
                  </div>
                  <div className="meta-item">
                    <span className="meta-icon">📊</span>
                    <span className="meta-text">{recipe.difficulty}</span>
                  </div>
                </div>
                
                <button className="recipe-btn">
                  Tarifi İncele
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Recipes;
